import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import InspectorDetails from "./InspectorDetails";
import UpdateInspector from "./UpdateInspector";

class InspectorRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/user" component={InspectorDetails} />
        <Route exact path="/user/edit" component={UpdateInspector} />
      </Switch>
    );
  }
}

export default InspectorRoutes;



// WEBPACK FOOTER //
// ./src/Inspector/InspectorRoutes.js